import { useState, useEffect, useContext } from "react";

import MainContext from "../MainContext";
import LogsFilter from "../Filters/LogsFilter";

import SortableGrid from "../Components/SortableGrid";

const sample_columns = [
    { FIELDNAME: "USERNAME", DISPLAYVALUE: "User", FIELDTYPE: "string" },
    { FIELDNAME: "LOCATION_ID", DISPLAYVALUE: "Location", FIELDTYPE: "string" },
    { FIELDNAME: "ACTION_MSG", DISPLAYVALUE: "Action Message", FIELDTYPE: "string" },
    { FIELDNAME: "INTERNAL_TRIP_NUMBER", DISPLAYVALUE: "Trip #", FIELDTYPE: "number" },
    { FIELDNAME: "LAST_MODIFIED", DISPLAYVALUE: "Last Modified", FIELDTYPE: "date" },
    { FIELDNAME: "STATUS", DISPLAYVALUE: "Status", FIELDTYPE: "enum", ENUM_ORDER: ["OK", "WARN", "ERROR"] },
    { FIELDNAME: "ACTION", DISPLAYVALUE: "Action", FIELDTYPE: "string" },
    { FIELDNAME: "ACTION_TYPE", DISPLAYVALUE: "Action Type", FIELDTYPE: "string" },
    { FIELDNAME: "IPADDRESS", DISPLAYVALUE: "IP Address", FIELDTYPE: "ip" },
    { FIELDNAME: "PROCESS", DISPLAYVALUE: "Process", FIELDTYPE: "string" },
  ];
  
  const sample_rows = [
    {
      USERNAME: "rnotwicz",
      LOCATION_ID: "NJHOB",
      ACTION_MSG: "Accepted",
      INTERNAL_TRIP_NUMBER: 10422,
      LAST_MODIFIED: "2025-09-09T16:30:00Z",
      STATUS: "OK",
      ACTION: "ACCEPT",
      ACTION_TYPE: "USER",
      IPADDRESS: "192.168.1.23",
      PROCESS: "Ingestor",
    },
    {
        USERNAME: "jdoe",
        LOCATION_ID: "NYC01",
        ACTION_MSG: "Login successful",
        INTERNAL_TRIP_NUMBER: 2345,
        LAST_MODIFIED: "2025-09-09T08:45:00Z",
        STATUS: "OK",
        ACTION: "LOGIN",
        ACTION_TYPE: "SYSTEM",
        IPADDRESS: "203.0.113.45",
        PROCESS: "AuthService",
      },
      {
        USERNAME: "asmith",
        LOCATION_ID: "NJHOB",
        ACTION_MSG: "Trip initiated",
        INTERNAL_TRIP_NUMBER: 6789,
        LAST_MODIFIED: "2025-09-08T22:15:00Z",
        STATUS: "WARN",
        ACTION: "START_TRIP",
        ACTION_TYPE: "USER",
        IPADDRESS: "198.51.100.23",
        PROCESS: "TripManager",
      },
      {
        USERNAME: "mjones",
        LOCATION_ID: "PHL22",
        ACTION_MSG: "Payment declined",
        INTERNAL_TRIP_NUMBER: 9876,
        LAST_MODIFIED: "2025-09-07T14:10:00Z",
        STATUS: "ERROR",
        ACTION: "PAYMENT",
        ACTION_TYPE: "SYSTEM",
        IPADDRESS: "192.0.2.77",
        PROCESS: "Billing",
      },
      {
        USERNAME: "knguyen",
        LOCATION_ID: "BOS15",
        ACTION_MSG: "Logout",
        INTERNAL_TRIP_NUMBER: 4521,
        LAST_MODIFIED: "2025-09-09T13:55:00Z",
        STATUS: "OK",
        ACTION: "LOGOUT",
        ACTION_TYPE: "USER",
        IPADDRESS: "203.0.113.89",
        PROCESS: "AuthService",
      },
      {
        USERNAME: "tgarcia",
        LOCATION_ID: "DC09",
        ACTION_MSG: "Trip completed",
        INTERNAL_TRIP_NUMBER: 5632,
        LAST_MODIFIED: "2025-09-10T01:20:00Z",
        STATUS: "OK",
        ACTION: "END_TRIP",
        ACTION_TYPE: "USER",
        IPADDRESS: "198.51.100.200",
        PROCESS: "TripManager",
      },
  ];

const LogPage = (props) => {

    const context = useContext(MainContext);

    const filterValue = {};

    const applyFilter = () => {

    }

    // useEffect(() => {
    //     if(this.props.dataReload){
    //         console.log("LOG RELOAD");
    //         this.props.setReload(false, () => {                
    //             console.log("LOG RELOAD AFTER CALL");
    //         });
    //     }
    // }, [props.dataReload])

    return (
        <div style={{position: "relative"}}>
            {
                // the filter
                context.hasFilter
                && context.filterOpen
                    ? <LogsFilter applyFilter={applyFilter} filterValue={filterValue} />
                    : null
            }
            <div>
                <SortableGrid rows={sample_rows} columns={sample_columns} />
            </div>
        </div>
    )
}

export default LogPage;
